// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleHeader_root__OM7TZ"};